import { all, fork } from 'redux-saga/effects';
import { allCoreSagas } from 'affiny-core/modules/saga';
import { bootstrapSaga } from 'affiny-core/redux/sagas/authSagas';
import { rateCardRootSaga } from 'affiny-core/redux/sagas/goToRatecardSagas';
import { messagesSaga } from './messages';
import { authSaga } from './auth';
import { accountSaga } from './account';
import { customerCareSaga } from './customer-care';
import { redirectSpecialOfferSaga } from './special-offer';

export function* rootSaga() {
  yield all([
    ...allCoreSagas,
    fork(bootstrapSaga),
    fork(messagesSaga),
    fork(authSaga),
    fork(redirectSpecialOfferSaga),
    fork(accountSaga),
    fork(rateCardRootSaga),
    fork(customerCareSaga),
  ]);
}
